import { StyleSheet, View } from 'react-native';

import { IconLockedOutline, IconStarRateFill, Markdown, Text, tokens } from '@fhs/ui';
import { Nullable } from '@rbi-ctg/frontend';

export function CardContent({
  title,
  description,
  isRedeemable,
}: {
  title: string;
  description?: Nullable<string>;
  isRedeemable: boolean;
}) {
  return (
    <View>
      <Text.Ui
        size="md"
        weight="semibold"
        style={{ color: isRedeemable ? tokens.colors.$houseDark : tokens.colors.$disabledText }}
      >
        {title}
      </Text.Ui>
      <View style={styles.descriptionContainer}>
        {isRedeemable ? (
          <IconStarRateFill color={tokens.colors.$houseYellow} />
        ) : (
          <IconLockedOutline />
        )}
        {description && <Markdown style={styles.description}>{description}</Markdown>}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  descriptionContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    flex: 1,
  },
  description: {
    flex: 1,
  },
});
